import useTenantState from '@/states/tenant.state';
import useAuthState from '@/states/auth.state';
import { env } from '@/utils/constants/env';

const useFreshRoles = (): string[] => {
  const { currentTenant } = useTenantState();
  const { tenants, isSuperAdmin } = useAuthState();

  if (isSuperAdmin) {
    return ['superadmin', 'admin', ...env.ADMIN_ROLES];
  }

  if (!currentTenant) {
    return [];
  }

  const freshTenant = tenants?.find(t => t.id === currentTenant.id);
  return freshTenant?.roles || [];
};

export const useHasRole = (allowedRoles: string[]): boolean => {
  const roles = useFreshRoles();

  if (!roles.length) {
    return false;
  }

  return roles.some(role => allowedRoles.includes(role));
};

export const useIsAdmin = (): boolean => {
  const { isSuperAdmin } = useAuthState();
  const hasAdminRole = useHasRole(env.ADMIN_ROLES);

  return isSuperAdmin || hasAdminRole;
};

export const useCurrentRoles = (): string[] => {
  return useFreshRoles();
};

export const useIsEmployee = (): boolean => {
  return useHasRole(['employee']);
};

export const useIsReadOnly = (): boolean => {
  const { isSuperAdmin } = useAuthState();
  const isEmployee = useIsEmployee();
  return isSuperAdmin || isEmployee;
};
